import i18n from "@/i18n"

export const STATUS_ERROS = {
  malFormado: 400,
  naoAutorizado: 401,
  naoPermitido: 403,
  naoEncontrado: 404,
  naoAceitavel: 406,
  conflito: 409,
  camposInvalidos: 422,
  erroInterno: 500,
  indisponivel: 503,
  requisicaoCanceladaPeloUsuario: "cancelado",
} as const

type S = typeof STATUS_ERROS

export type StatusHTTP = keyof S
export type StatusCodigoHTTP = S[keyof S]

type Loc = string | number

interface DetalheErroValidacao {
  loc: Loc[]
  msg: string
  type: string
}
interface ErroDeValidacao {
  detail: DetalheErroValidacao[]
}
export interface MensagemErro {
  tipo: StatusHTTP
  mensagem: string
  detalhe: string
  codigo: StatusCodigoHTTP
  original?: any
  origem?: string
}
type MapeadorApiErros = {
  [key in StatusCodigoHTTP]: (erro?: any) => MensagemErro
}
interface ErroCustomizado {
  tipo: string
  mensagem: string
  detalhe: string
  codigo?: number
  origem?: string
}

type ParamsErroCustomizado = {
  mensagem: string
  detalhe: string
  recurso: string
}
export type Erro = ErroCustomizado | MensagemErro

const { t } = i18n.global

const erro422 = (erro: any): MensagemErro => {
  const original = erro.response.data.detail
  return {
    tipo: "camposInvalidos",
    mensagem: t("422.mensagem"),
    detalhe: original[0].msg,
    codigo: 422,
    original,
  }
}
const erro400 = (erro: any): MensagemErro => {
  const detalhe = erro.response?.data?.detail
  return {
    tipo: "malFormado",
    mensagem: t("400.mensagem"),
    detalhe: detalhe || t("400.detalhe"),
    codigo: 400,
  }
}
const erro403 = (erro: any): MensagemErro => {
  return {
    tipo: "malFormado",
    mensagem: t("403.mensagem"),
    detalhe: t("400.detalhe"),
    codigo: 403,
    original: erro.config,
  }
}
const erro401 = (erro: any): MensagemErro => {
  const detalhe = erro.response.data.detail
  return {
    tipo: "naoAutorizado",
    mensagem: t("401.mensagem"),
    detalhe: detalhe,
    codigo: 401,
  }
}
const erro404 = (): MensagemErro => {
  return {
    tipo: "naoEncontrado",
    mensagem: t("404.mensagem"),
    detalhe: t("404.detalhe"),
    codigo: 404,
  }
}
const erro409 = (erro?: any): MensagemErro => {
  const detalhe = erro.response.data.detail
  return {
    tipo: "conflito",
    mensagem: t("409.mensagem"),
    detalhe,
    codigo: 409,
  }
}
const erro406 = (erro: any): MensagemErro => {
  const detalhe = erro.response.data.detail
  return {
    tipo: "naoAceitavel",
    mensagem: t("406.mensagem"),
    detalhe: detalhe || t("406.detalhe"),
    codigo: 406,
  }
}
const erro500 = (erro?: any): MensagemErro => {
  return {
    tipo: "erroInterno",
    mensagem: t("500.mensagem"),
    detalhe: t("500.detalhe"),
    codigo: 500,
  }
}
const erro503 = (): MensagemErro => {
  return {
    tipo: "erroInterno",
    mensagem: t("503.mensagem"),
    detalhe: t("503.mensagem"),
    codigo: 503,
  }
}
const cancelado = (): MensagemErro => {
  return {
    tipo: "requisicaoCanceladaPeloUsuario",
    mensagem: t("cancelado.mensagem"),
    detalhe: t("cancelado.detalhe"),
    codigo: "cancelado",
  }
}
const errosPorStatus: MapeadorApiErros = {
  400: erro400,
  403: erro403,
  401: erro401,
  404: erro404,
  406: erro406,
  409: erro409,
  422: erro422,
  500: erro500,
  503: erro503,
  cancelado: cancelado,
}
export function adaptarMensagemErros(
  erro: ErroDeValidacao | any,
  status: number | string
): MensagemErro {
  return errosPorStatus[status](erro)
}

export const erroCustomizado = ({
  mensagem,
  detalhe,
  recurso,
}: ParamsErroCustomizado): Erro => {
  return {
    tipo: "customizado",
    mensagem,
    detalhe,
    codigo: 0,
    origem: recurso,
  }
}
